<template>
    <information-popup modal-id="inscriptionExamplesPopup">
        <template slot="header">Inscription Examples</template>
        <slot>
            <div class="modal-body inscription-modal">
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">ANNIVERSARY</h3>
                        <p><strong>4x8</strong></p>
                        <p>CELEBRATING OUR</p>
                        <p>5TH ANNIVERSARY</p>
                        <p>ANNA &amp; TREY '11</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>OUR JOURNEY</p>
                        <p>BEGAN HERE</p>
                        <p>IN 1996</p>
                        <p>TWENTY YEARS</p>
                        <p>&amp; STILL STRONG</p>
                        <p>SAM &amp; CODY DUNN</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>BEST DUO</p>
                        <p>MARRIAGE &amp;</p>
                        <p>FOOTBALL!</p>
                        <p>JOE &amp; MEG DIETZ</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">FAMILY</h3>
                        <p><strong>4x8</strong></p>
                        <p>THE REED FAMILY</p>
                        <p>EST. 2003</p>
                        <p>NATHAN &amp; JILL</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>A FAMILY OF</p>
                        <p>FANS!!</p>
                        <p>THE BAKERS</p>
                        <p>JASON, ABBY</p>
                        <p>JESSICA, JOHN</p>
                        <p>&amp; MELISSA</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>FANS FOR LIFE!!</p>
                        <p>MEG, RYAN</p>
                        <p>JOE &amp; SAMANTHA</p>
                        <p>PETERSON</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">FATHER'S DAY</h3>
                        <p><strong>4x8</strong></p>
                        <p>TO THE BEST DAD</p>
                        <p>AND #1 FAN</p>
                        <p>JOSE GONZALES</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>IN HONOR OF</p>
                        <p>OUR LOVING</p>
                        <p>FATHER</p>
                        <p>AND FRIEND</p>
                        <p>ALEXANDER GREER</p>
                        <p>1969 - 2014</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>LIKE FATHER</p>
                        <p>LIKE SON</p>
                        <p>TYLER &amp; TIMOTHY</p>
                        <p>McCABE</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">MOTHER'S DAY</h3>
                        <p><strong>4x8</strong></p>
                        <p>HAPPY MOTHER'S</p>
                        <p>DAY MOM!</p>
                        <p>JEN &amp; PAT BRADY</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>DEDICATED TO</p>
                        <p>OUR MOTHER</p>
                        <p>MEG MARSHALL</p>
                        <p>WITH OUR LOVE</p>
                        <p>MITCH &amp; MILO</p>
                        <p>MARSHALL</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>SANDRA BRADY</p>
                        <p>#1 MOM!</p>
                        <p>WE LOVE YOU</p>
                        <p>JEN &amp; DONNY</p>
                    </div>
                </div>
                <hr/>
                <div class="row">
                    <div class="col-sm-3">
                        <h3 class="text-danger">TEAM</h3>
                        <p><strong>4x8</strong></p>
                        <p>LOYAL FANS</p>
                        <p>OLIVER &amp; TESSA</p>
                        <p>MCDERMOTT</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>CELEBRATING</p>
                        <p>26 YEARS OF</p>
                        <p>PRIDE!!</p>
                        <p>MAY THERE BE</p>
                        <p>MANY MORE!!</p>
                        <p>THE MORGANS</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>SHOW ME YOUR</p>
                        <p>SPIRIT!!</p>
                        <p>THE PERRYS</p>
                        <p>- 2016 -</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">INSPIRING</h3>
                        <p><strong>4x8</strong></p>
                        <p>IF YOU BUILD IT</p>
                        <p>THEY WILL COME!</p>
                        <p>BRAXTON FAMILY</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>THE FUTURE</p>
                        <p>BELONGS TO THOSE</p>
                        <p>WHO BELIEVE IN</p>
                        <p>THE BEAUTY OF</p>
                        <p>THEIR DREAMS.</p>
                        <p>ELENOR ROOSEVELT</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>IT ALL STARTED</p>
                        <p>WITH A PIGSKIN!</p>
                        <p>LOYAL FANS</p>
                        <p>JT &amp; MEG FRIES</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">REMEMBRANCE</h3>
                        <p><strong>4x8</strong></p>
                        <p>IN HONOR OF</p>
                        <p>DOMINICK VANCE</p>
                        <p>1969 - 2013</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>IN MEMORY OF</p>
                        <p>MICHAEL HADLEY</p>
                        <p>LOST BUT</p>
                        <p>NOT FORGOTTEN!</p>
                        <p>THANK YOU FOR</p>
                        <p>YOUR SERVICE</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>DEDICATED TO</p>
                        <p>OUR ANGEL</p>
                        <p>IN THE STARS</p>
                        <p>MADELINE REED</p>
                    </div>
                    <br class="visible-xs">
                    <div class="col-sm-3">
                        <h3 class="text-danger">GENERAL</h3>
                        <p><strong>4x8</strong></p>
                        <p>REESE DEMARC &amp;</p>
                        <p>THOMAS MOORE</p>
                        <p>- 2015 -</p>
                        <br/>
                        <p><strong>8x8 Brick</strong></p>
                        <p>REMEMBERING</p>
                        <p>THE GOOD TIMES!</p>
                        <p>MR. &amp; MRS.</p>
                        <p>JONATHAN</p>
                        <p>CALLAHAN</p>
                        <p>EST. 1999</p>
                        <br/>
                        <p><strong>8x8 Logo Brick</strong></p>
                        <p>FAN SINCE '75</p>
                        <p>THROUGH GOOD</p>
                        <p>TIMES &amp; BAD</p>
                        <p>ALEX KNOLL</p>
                    </div>
                </div>
            </div>
        </slot>
    </information-popup>
</template>

<script type="text/jsx">
    import InformationPopup from '@/components/popup/information-popup.vue';
    export default {
        name: 'inscription-examples',
        components: {
            'information-popup': InformationPopup
        }
    }
</script>

<style lang="scss" scoped>
    .inscription-modal {
        h3,
        p {
            white-space: nowrap;
        }
    }
</style>



// WEBPACK FOOTER //
// InscriptionExamples.vue?78fe908b